import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: theme.palette.common.white,
      '&:last-child > td': {
        borderBottom: 'none',
      },
    },
    cell: {
      padding: theme.spacing(1, 2),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    cellText: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
    },
    featureLimitedLabel: {
      paddingLeft: theme.spacing(0.5),
      color: COLORS.error.active,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
    },
    track: {
      background: COLORS.neutral.mediumGray,
      borderColor: COLORS.neutral.mediumGray,
    },
    connected: {},
    actionButton: {
      width: 130,
      fontWeight: theme.typography.fontWeightMedium,
    },
    disconnectButton: {
      color: COLORS.error.active,
    },
  }),
  { name: 'AccountsTable' }
);
